<div class="title-wrapper">
  <div
    class="back"
    (click)="onBack()"
  >
    <span class="pi pi-arrow-left"></span>
  </div>
  <div class="title">Get started with Opportunities</div>
</div>

<div class="no-results">
  <div class="main">
    <div class="icon"></div>
    <div class="main-title">
      Opportunities are the way that <b>Suppliers</b> find new work on
      Sustainment.
    </div>
    <div class="subtitle">
      You can browse open opportunities and may also be invited to bid on a
      private project.
    </div>
    <div class="action">
      <s-button
        type="primary"
        label="Search for opportunities"
        size="large"
        (click)="goToOpportunities()"
      ></s-button>
    </div>
  </div>

  <div class="secondary">
    <div class="grid centered">
      <div class="sm:col-4 col-12">
        <div class="box">
          <div class="header">Participate in Posted Opportunities</div>
          <div class="text">
            Submit requests to participate in our Community Opportunities from
            current customers or new ones.
          </div>
        </div>
      </div>
      <div class="sm:col-4 col-12">
        <div class="box">
          <div class="header">Get Invited to Opportunities</div>
          <div class="text">
            Fill out your profile and connect with Buyers to make sure you get
            invited to Private Opportunities.
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
